import { List, Map } from 'immutable';
import { getColumnDefaults } from 'components/TransactionRegister/transactionsConfig';
import { overviewLayoutVersion } from 'containers/OverviewPage/config'

const defaultACMEPreferences =
  {
    transactionRegister: {
      doubleAmounts: false,   // pffffhhhhttttt on Kelly and Kristen
      editDownloaded: true,
      deleteDownloaded: true,  // this comes with lots of warnings, so right now default on
      autoSave: true,
      splitsInDialog: false,
      autoSearch: false,
      longCats: false,
      continuousCreate: false,
      showCurrencySymbol: false,
      wrapText: false,
      showAccountColors: false,
      currencySymbol: '$',
      registerComfort: 'comfortable',
      regFieldsSort: {
        cashFlow: new List(getColumnDefaults()),
      },
    },
    accountsPrefs: null,
    accountBarBalanceType: 'online',
    accountDrawerDefaultOpen: true,
    accountBarShowCents: true,
    accountNodePrefs: new Map({}),
    hideIgnoredIncome: false,
    hideIgnoredBills: false,
    hideIgnoredGoals: false,
    projectedOpen: true,
    setupStateIndex: null,

    overviewPageLayout: new List(),
    overviewPageLayoutVersion: overviewLayoutVersion,
    swlOrder: 'BY_DATE',
    dateRangeProjectedBalances: 'thirty',
    qCardsOffByDefault: null,
    autoRefresh: true,
    kioskmode: false,

    currencySymbol: '$',
    theme: null,
  };

const defaultQUICKENPreferences =
  {

    transactionRegister: {
      doubleAmounts: false,   // pffffhhhhttttt on Kelly and Kristen
      editDownloaded: true,
      deleteDownloaded: true,  // this comes with lots of warnings, so right now default on
      autoSave: true,
      splitsInDialog: false,
      autoSearch: false,
      longCats: false,
      continuousCreate: false,
      showCurrencySymbol: false,
      wrapText: false,
      showAccountColors: false,
      currencySymbol: '$',
      registerComfort: 'normal',
      regFieldsSort: {
        cashFlow: new List(getColumnDefaults()),
        credit: new List(getColumnDefaults('credit')),
      },
    },
    accountsPrefs: null,
    accountBarBalanceType: 'today',
    accountBarShowCents: true,
    accountDrawerDefaultOpen: true,
    accountNodePrefs: new Map({}),
    projectedOpen: false,
    upcomingOpen: true,

    overviewPageLayout: new List(),
    qCardsOffByDefault: null,
    autoRefresh: true,
    kioskmode: false,
    dateRangeProjectedBalances: 'thirty',
    currencySymbol: '$',
    theme: null,
  };

export const defaultDatasetPreferences = (process.env.PROJECT === 'acme') ? defaultACMEPreferences : defaultQUICKENPreferences;
export const defaultUserPreferences = {
  datasetIdsUsed: new List([]),
  webApp: {
    windowsReviewedWarningEnabled: true,
  },
};

export function regFieldsSortType(regFieldsSort, type) {
  if (regFieldsSort && (type.toLowerCase() in regFieldsSort)) {
    return type.toLowerCase();
  }
  return 'cashFlow';
}
